/* eslint-disable filenames/match-exported */
// import { genericAPIActionTypes, genericAPIActionCreator } from '../../util';
// import * as api from '../../api';

const ACTIONS = {
  SUBMIT_CONTACT_FORM: 'ContactForm:Submited',
  CONTACT_FORM_SUCCESS: 'ContactForm:Success',
  CONTACT_FORM_FAILED: 'ContactForm:Failed',
};

export default ACTIONS;

export const submitContactForm = values => ({
  type: ACTIONS.SUBMIT_CONTACT_FORM,
  values,
});

export const contactFormSuccess = () => ({
  type: ACTIONS.CONTACT_FORM_SUCCESS,
});

export const contactFormFailed = error => ({
  type: ACTIONS.CONTACT_FORM_FAILED,
  error,
});



// WEBPACK FOOTER //
// ./src/hub_spot_form/actions.js